import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import AccountHeader from 'account/AccountHeader'
import RightSection from 'account/RightSection'
import { Col, Row, Skeleton } from 'antd'

import localStorage from 'core/application/commons/localStorage'
import { InfoFromCode, getInfoFromCode } from 'core/application/ichraDecisionTool/prospectSignup/welcome'

import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'
import Content from 'common/components/layout/Content'
import Footer from 'common/components/layout/Footer'
import Layout from 'common/components/layout/Layout'

import useUrlQueryParam from 'common/hooks/useUrlQueryParam'

import { ROUTE_PATHS } from 'common/routePaths'

import { ICHRA_DECISION_TOOL_SIGNUP_PATH } from './Routes'

import './SignupStyles.less'

const { ICHRA_DECISION_TOOL_PATH } = ROUTE_PATHS

const Welcome = () => {
  let code = useUrlQueryParam('code')
  let history = useHistory()
  const { t: translate } = useTranslation('ichra-decision-tool')
  const headerItems: string[] = [
    translate('prospect-signup.right-section.subtitle-1'),
    translate('prospect-signup.right-section.subtitle-2'),
    translate('prospect-signup.right-section.subtitle-3'),
  ]

  const [infoFromCode, setInfoFromCode] = useState<InfoFromCode | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [invalidToken, setInvalidToken] = useState<boolean>(false)

  useEffect(() => {
    if (code) {
      localStorage.setProspectSignupCode(code)
      setLoading(true)
      getInfoFromCode(code)
        .then((response) => {
          setInfoFromCode(response)
        })
        .catch(() => {
          setInvalidToken(true)
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      setInvalidToken(true)
    }
  }, [code])

  return (
    <Layout>
      <Content>
        <Row className="height-100">
          <Col xs={14}>
            <AccountHeader />
            <Skeleton loading={loading}>
              {infoFromCode && (
                <Row>
                  <Col span={14} offset={6} className="mt-64">
                    <div>
                      <h2>{translate('prospect-signup.welcome.title').replace('[]', infoFromCode.companyName)}</h2>
                    </div>
                    <div>
                      <p className="color-gray-8">
                        {translate('prospect-signup.welcome.description-paragraph1').replace(
                          '[]',
                          infoFromCode.companyName,
                        )}
                      </p>
                      <p className="color-gray-8 mt-24">
                        {translate('prospect-signup.welcome.description-paragraph2')}
                      </p>
                      <ul className="pl-24 mt-24">
                        <li>
                          <p className="color-gray-8">{translate('prospect-signup.welcome.description-paragraph3')}</p>
                        </li>
                        <li>
                          <p className="color-gray-8">{translate('prospect-signup.welcome.description-paragraph4')}</p>
                        </li>
                      </ul>
                    </div>
                    <div className="mt-32">
                      <Button
                        type="primary"
                        iconPosition="right"
                        icon="far fa-arrow-right"
                        className="full-width"
                        onClick={() => {
                          history.push(`${ICHRA_DECISION_TOOL_PATH}/${ICHRA_DECISION_TOOL_SIGNUP_PATH}`)
                        }}
                      >
                        {translate('get-started')}
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}

              {invalidToken && (
                <Row>
                  <Col span={14} offset={7} className="mt-64">
                    <div>
                      <Icon type="far fa-exclamation-circle fa-2x" className="color-green-6 " fontAwesome />
                    </div>

                    <div className="mt-16">
                      <h2>{translate('prospect-signup.welcome.invalid-token-title')}</h2>
                    </div>
                    <div className="mt-24">
                      <p className="color-gray-8">{translate('prospect-signup.welcome.invalid-token-description')}</p>
                    </div>
                  </Col>
                </Row>
              )}
            </Skeleton>
          </Col>
        </Row>
        <Col xs={8} className="account-right-section-login">
          <RightSection headerTitle={translate('prospect-signup.right-section.title')} headerItems={headerItems} />
        </Col>
      </Content>
      <Footer className="fixed_bottom" />
    </Layout>
  )
}

export default Welcome
